import React from "react";
import styled, { keyframes } from "styled-components";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const blink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;

const Wrapper = styled.div`
  font-size: 17px;
  line-height: 1.7;
  color: #1f2937;
  word-break: break-word;

  p {
    margin: 0 0 8px 0;
  }
  p:last-child {
    margin-bottom: 0;
  }
  strong {
    font-weight: 600;
  }
  em {
    font-style: italic;
  }
  ul,
  ol {
    margin: 4px 0 8px 0;
    padding-left: 20px;
  }
  ul:last-child,
  ol:last-child {
    margin-bottom: 0;
  }
  li {
    margin: 2px 0;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 600;
    margin: 8px 0 4px 0;
  }
  h1:first-child,
  h2:first-child,
  h3:first-child {
    margin-top: 0;
  }
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 18px;
  }
  h3 {
    font-size: 17px;
  }
  h4,
  h5,
  h6 {
    font-size: 16px;
  }
  code {
    background: #f3f4f6;
    border-radius: 3px;
    padding: 1px 4px;
    font-family: monospace;
    font-size: 14px;
  }
  pre {
    background: #f3f4f6;
    border-radius: 6px;
    padding: 10px 12px;
    overflow-x: auto;
    margin: 4px 0 8px 0;
  }
  pre code {
    background: none;
    padding: 0;
  }
  table {
    border-collapse: collapse;
    width: 100%;
    margin: 8px 0;
    font-size: 14px;
  }
  th,
  td {
    border: 1px solid #d1d5db;
    padding: 6px 12px;
    text-align: left;
  }
  th {
    background: #f3f4f6;
    font-weight: 600;
  }
  tr:nth-child(even) td {
    background: #f9fafb;
  }
`;

const Cursor = styled.span`
  display: inline-block;
  width: 2px;
  height: 16px;
  background: #374151;
  margin-left: 1px;
  vertical-align: text-bottom;
  animation: ${blink} 0.7s step-end infinite;
`;

function normalizeHtmlLineBreaks(text) {
  return text.replace(/<br\s*\/?>/gi, "  \n");
}

export default function StreamingText({ content, isStreaming }) {
  return (
    <Wrapper>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {normalizeHtmlLineBreaks(content)}
      </ReactMarkdown>
      {isStreaming && <Cursor data-testid="streaming-cursor" />}
    </Wrapper>
  );
}
